module.exports = __webpack_public_path__ + "static/media/blog-posts.fef9d19e.png";